import { render } from "./nav-support-icon.svg?vue&type=template&id=d4e5c46c"
import script from "./nav-support-icon.svg?vue&type=script&lang=js"
export * from "./nav-support-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2958/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__